<template>
  <div class="full-height">
    <!-- Setup grid start-->
    <div type="flex" :gutter="24">
        <el-row>
            <el-col :span="4">                
                <img class="reports-logo" src="/static/images/logos/Report_graph.svg" />                
            </el-col>
            <el-col :span="20">
                <el-row>
                    <el-col class="set-up-confluera">
                        <b>Set up Confluera Cloud Security Reports. </b>
                        <a @click="loadDocumentation('page-partner-signals-wef')">Learn More</a>
                    </el-col>
                </el-row>
                <h5 class="top-header margin-bottom-10">
                    Threat and Incidents
                </h5>
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-card shadow="hover" class="cursor-pointer">                      
                      <h2>CxDR Threat Weekly</h2>
                      <p>Weekly summary of active threats and insights…</p>
                      <p class="float-right">
                        <el-button size="medium" :type="!savedPreferenceWeekly ? 'primary' : null" @click="openSubscribeUnsubscribeDialog('subscribe', 'CxDR Threat Weekly Report')">{{ !savedPreferenceWeekly ? 'Subscribe' : 'Unsubscribe'}}</el-button>
                        <el-button 
                          type="text"
                          style="padding-left:16px"
                          class="display-block text-center run-now"
                          @click="openRunNowDialog('CxDR Threat Weekly Report (Run Now)', 'Weekly')"
                        >
                          Run now
                        </el-button>
                      </p>
                    </el-card>
                  </el-col>
                  <el-col :span="8">
                    <el-card shadow="hover" class="cursor-pointer">                      
                      <h2>CxDR Threat Monthly</h2>
                      <p>Monthly summary of active threats and insights…</p>
                      <p class="float-right">
                        <el-button size="medium" :type="!savedPreference ? 'primary' : null" @click="openSubscribeUnsubscribeDialog('subscribe', 'CxDR Threat Monthly Report')">{{ !savedPreference ? 'Subscribe' : 'Unsubscribe'}}</el-button>
                        <el-button 
                          type="text"
                          style="padding-left:16px"
                          class="display-block text-center run-now"
                          @click="openRunNowDialog('CxDR Threat Monthly Report (Run Now)', 'Monthly')"
                        >
                          Run now
                        </el-button>
                      </p>
                    </el-card>
                  </el-col>                  
                </el-row>
                <!-- Future amendment 
                  <el-row :gutter="24" class="margin-top-25">
                  <el-col :span="8">
                    <el-card shadow="hover" class="cursor-pointer">                      
                      <h2>+ Request</h2>
                      <p class="float-right">
                        <el-button size="medium" type="primary">Request</el-button>
                      </p>
                    </el-card>
                  </el-col>                  
                </el-row> -->
            </el-col>
        </el-row>
        <!-- Setup grid end -->
    </div>
    <el-dialog :title="dialogueBoxTitle" :visible.sync="openSubscribeUnsubscribeDialogVisible" class="subscription-dialog">
      <el-row :gutter="24">
        <el-col :span="8">
          <ol type="1">
            <li><strong>Threat status</strong> of your deployment including active attacks, detections and some critical vulnerabilities.</li>
            <li><strong>Snapshot of Assets and Signals</strong> including VMs, Containers,  Confluera agent status and Integrations.</li>
            <li><strong>Summary</strong> of Allowlist exceptions Anomalies and Insights.</li>
          </ol>
        </el-col>
        <el-col :span="16">
          <el-form>
            <div class="container">
              <el-col>            
                <span>
                  <i class="far fa-calendar" aria-hidden="true"></i>
                  <slot class="title ">&nbsp;<strong> Select Monthly Subscription Date </strong></slot>
                </span>
              <div class="box grow flex column">
                <el-form-item prop="model.monthlySubscriptionDate">
                  <el-radio-group v-model="subscriptionForm.model.monthlySubscriptionDate">
                    <el-radio label="1">
                      <span>1st day of the month</span>
                    </el-radio>
                    <el-radio label="15">
                      <span>15th day of the month</span>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>

                <!-- Future amendment  
                  <div>                
                  <el-row :gutter="24">
                    <el-col :span="8">
                      <span>
                        <i class="far fa-sort-alt"></i>
                      </span>Delivery
                    </el-col>
                    <el-col :span="16">
                        <el-form-item prop="model.delivery">                  
                          <el-checkbox-group v-model="subscriptionForm.model.delivery" class="float-left">
                            <el-checkbox v-for="item in deliveryOptions" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
                          </el-checkbox-group>
                          <el-link class="float-right text-underline" @click="openAddonChannelDialog">
                            Add channels
                          </el-link>
                        </el-form-item>                        
                    </el-col>
                  </el-row>
                </div> -->
                <!-- <div>
                  <el-row :gutter="24">
                    <el-col :span="8">
                      Slack channel
                    </el-col>
                    <el-col :span="16">
                        <el-form-item prop="model.slackChannel">    
                          <el-select v-model="subscriptionForm.model.slackChannel" placeholder="# Cloud" class="dropdown-border full-width">
                            <el-option v-for="item in slackChannels" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                    </el-col>
                  </el-row>
                </div> -->
                <div class="mt-12">
                  <el-row :gutter="24" class="pl-24">
                    <el-col>
                      The report will be delivered to your <strong>Email</strong>
                    </el-col>
                  </el-row>
                </div>
                <div style="margin:30px 0">
                  <div class="title bold">
                     <i class="far fa-file-pdf" aria-hidden="true"></i>
                    Format: PDF</div>
                </div>
              </div>
              </el-col>
            </div>
          </el-form>
        </el-col>
      </el-row>      
      <div class="display-inline-block full-width">
        <span slot="footer" class="dialog-footer float-right">
          <el-button @click="openSubscribeUnsubscribeDialogVisible = false" :disabled="!checkForDeleteMonthly">
            Delete
          </el-button>
          <el-button @click="openUnsubscribeDialog" :disabled="!checkForDeleteMonthly">
            Unsubscribe
          </el-button>
          <el-button type="primary" v-if="!checkForDeleteMonthly" @click="openSubscribeSuccessDialog">
            Subscribe
          </el-button>
          <!-- <el-button type="primary" v-if="currentAction === 'update'" @click="openUpdateSuccessDialog">
            Update
          </el-button> -->
        </span>
      </div>
    </el-dialog>

    <!-- Weekly report section -->
    <el-dialog :title="dialogueBoxTitle" :visible.sync="openSubscribeUnsubscribeDialogVisibleWeekly" class="subscription-dialog">
      <el-row :gutter="24">
        <el-col :span="8">
          <ol type="1">
            <li><strong>Threat status</strong> of your deployment including active attacks, detections and some critical vulnerabilities.</li>
            <li><strong>Snapshot of Assets and Signals</strong> including VMs, Containers,  Confluera agent status and Integrations.</li>
            <li><strong>Summary</strong> of Allowlist exceptions Anomalies and Insights.</li>
          </ol>
        </el-col>
        <el-col :span="16">
          <el-form>
            <div class="container">
              <el-col>            
                <span>
                  <i class="far fa-calendar" aria-hidden="true"></i>
                  <slot class="title ">&nbsp;<strong>Your Weekly report will be generated on Monday</strong></slot>
                </span>
              <div class="box grow flex column">
                <div class="mt-12">
                  <el-row :gutter="24" class="pl-24">
                    <el-col>
                      The report will be delivered to your <strong>Email</strong>
                    </el-col>
                  </el-row>
                </div>
                <div style="margin:30px 0">
                  <div class="title bold">
                     <i class="far fa-file-pdf" aria-hidden="true"></i>
                    Format: PDF</div>
                </div>
              </div>
              </el-col>
            </div>
          </el-form>
        </el-col>
      </el-row>      
      <div class="display-inline-block full-width">
        <span slot="footer" class="dialog-footer float-right">
          <el-button @click="openSubscribeUnsubscribeDialogVisibleWeekly = false" :disabled="!checkForDelete">
            Delete
          </el-button>
          <el-button @click="openUnsubscribeDialog" :disabled="!checkForDelete">
            Unsubscribe
          </el-button>
          <el-button type="primary" v-if="!checkForDelete" @click="openSubscribeSuccessDialogWeekly">
            Subscribe
          </el-button>
          <!-- <el-button type="primary" v-if="currentAction === 'update'" @click="openUpdateSuccessDialog">
            Update
          </el-button> -->
        </span>
      </div>
    </el-dialog>

    <!-- Run now modal start -->
    <el-dialog :title="dialogueBoxTitle" :visible.sync="openRunNowDialogVisible" class="subscription-dialog">
        <el-row :gutter="24">
          <el-col :span="8">
            <ol type="1">
              <li><strong>Threat status</strong> of your deployment including active attacks, detections and some critical vulnerabilities.</li>
              <li><strong>Snapshot of Assets and Signals</strong> including VMs, Containers,  Confluera agent status and Integrations.</li>
              <li><strong>Summary</strong> of Allowlist exceptions Anomalies and Insights.</li>
            </ol>
          </el-col>
          <el-col :span="16">
            <el-form>
              <div class="container">
                <el-col>            
                  <span>
                    <i class="far fa-calendar" aria-hidden="true"></i>
                    <slot class="title ">&nbsp;<strong> You've requested Confluera {{reportSubscriptionType}} Report </strong></slot>
                  </span>
                  <div class="box grow flex column">
                    <div class="mt-24">
                      <span>
                        <i class="far fa-clock" aria-hidden="true"></i>
                        The report will be delivered to within <strong>5 mins</strong> to your <strong>Email</strong>
                      </span>
                    </div>
                    <div style="margin:30px 0">
                      <div class="title bold">
                        <i class="far fa-file-pdf" aria-hidden="true"></i>
                        Format: PDF</div>
                    </div>
                  </div>
                </el-col>
              </div>
            </el-form>
          </el-col>
        </el-row>      
        <div class="display-inline-block full-width">
          <span slot="footer" class="dialog-footer float-right">
            <el-button type="primary" @click="runnowEntryRequest">
              Submit
            </el-button>
          </span>
        </div>
    </el-dialog>
  <!-- unsubscribe modal start -->
    <el-dialog :visible.sync="openUnsubscribeDialogVisible">
      <div class="text-center padding-20">
        <h2>
          {{ dialogueBoxTitle }}
        </h2>
        <div class="cancel-logo">
              <img style="height:69px; width:78px;" src="/static/images/unsubscribe.svg" alt="Svg coming soon" />
        </div>
        <p>
          You selected to unsubscribe. You will no longer receive the report. Please confirm below.
        </p>
        <p>
          <el-button type="primary" @click="unsubscribe()">
            Confirm
          </el-button>
        </p>
        <p>
          <el-link @click="openUnsubscribeDialogVisible = false">
            Cancel
          </el-link>
        </p>
      </div>
    </el-dialog>
  <!-- unsubscribe modal end -->

  <!-- subscribe modal start -->
    <el-dialog :visible.sync="openSubscribeSuccessDialogVisible">
      <div class="text-center padding-20">
        <h2>
          Success!
        </h2>
        <div class="success-logo">
              <img style="height:69px; width:78px;" src="/static/images/success_logo.svg" alt="SUCCESS" />
        </div>
        <p>
          You've added Confluera Monthly report. Now you'll be able to track, share and archive your detections and insights.
        </p>
        <p style="font-weight:bold"> 
          Tp add more, edit, delete or pause, got to:
        </p>
        <p>
          <router-link :to="{ name: 'reports-scheduled'}">
            <el-button type="primary">
              <span style="color:#ffffff;">
                Scheduled Reports
              </span>
            </el-button>
          </router-link>
        </p>
      </div>
    </el-dialog>
    <!-- subscribe modal end -->  

    <!-- subscribe modal start for RUN NOW -->
    <el-dialog :visible.sync="openSubscribeDialogForRunnow">
      <div class="text-center padding-20">
        <h2>
          Success!
        </h2>
        <div class="success-logo">
              <img style="height:69px; width:78px;" src="/static/images/success_logo.svg" alt="SUCCESS" />
        </div>
        <p>
          You've will receive requested report with in 5 minutes on your email.
        </p>
        <p style="font-weight:bold"> 
          Tp add more, edit, delete or pause, got to:
        </p>
        <p>
          <router-link :to="{ name: 'reports-scheduled'}">
            <el-button type="primary">
              <span style="color:#ffffff;">
                Scheduled Reports
              </span>
            </el-button>
          </router-link>
        </p>
      </div>
    </el-dialog>
    <!-- subscribe modal end for RUN NOW--> 

    <!-- Add slack channels Modal start -->
    <el-dialog :visible.sync="openAddChannelDialogVisible">
      <div class="text-center padding-20">
        <h2>
          Confluera Reports in Slack
        </h2>
        <div class="slack-logo">
          <img style="height:69px; width:78px;" src="/static/images/slack.svg" alt="slack logo"/>
        </div>
        <p>
          To share your Confluera Reports in Slack first turn on Slack in <strong>Accounts.</strong>
        </p>
        <p>
          Then add Slack channels in <strong>Settings.</strong>
        </p>
        <p>
          <el-button type="primary" @click="redirectTo('/admin/account?view=slack-notification')">
            Turn on slack
          </el-button>
        </p>
      </div>
    </el-dialog>
    <!-- Add slack channels Modal end -->  

  </div>
</template>

<script>
import PageHeaders from '@/components/layout/PageHeaders.vue'
import { mapGetters } from 'vuex'
import {
  SENDGRID_REPORT_ENTRIES_CREATE,
  SENDGRID_REPORT_UPDATE_REQUEST,
  SENDGRID_REPORT_DELETE_REQUEST,
  SENDGRID_REPORT_PREFERENCES_FETCH,
  SENDGRID_REPORT_RUNNOW_CREATE
} from '@/store/modules/reports/sendgrid-reports.type.js'

export default {
  name: 'ReportsTemplate',
  data () {
    return {
      currentAction: '',
      dialogueBoxTitle: '',
      reportSubscriptionType: '',
      openRunNowDialogVisible: false,
      openSubscribeUnsubscribeDialogVisible: false,
      openSubscribeUnsubscribeDialogVisibleWeekly: false,
      openUnsubscribeDialogVisible: false,
      openSubscribeSuccessDialogVisible: false,
      openAddChannelDialogVisible: false,
      subscriptionForm: {
        model: {
          monthlySubscriptionDate: '',
          delivery: [],
          slackChannel: ''
        }
      },
      deliveryOptions: [
        {
          label: 'Email',
          value: 'email'
        },
        {
          label: 'Slack',
          value: 'slack'
        }
      ],
      slackChannels: [
        {
          label: '# Cloud',
          value: 'cloud'
        }
      ],
      checkForDelete: false,
      checkForDeleteMonthly: false,
      savedPreference: false,
      savedPreferenceWeekly: false,
      openSubscribeDialogForRunnow: false
    }
  },
  methods: {
    openRunNowDialog(title, type) {
      this.dialogueBoxTitle = title
      this.reportSubscriptionType = type
      this.openRunNowDialogVisible = true
    },
    openSubscribeUnsubscribeDialog (action, title) {
      this.dialogueBoxTitle = title;
      this.currentAction = action;
      if (action === 'subscribe' && title === 'CxDR Threat Monthly Report') {
        this.$store.dispatch(SENDGRID_REPORT_PREFERENCES_FETCH, {
          userEmail: this.userProfile.email,
          dateSelection: "Monthly"
        }).then(() => {
          // console.log(this.userReportPreferences)
          if (this.userReportPreferences.data === "none") {
            this.checkForDeleteMonthly = false
            this.openSubscribeUnsubscribeDialogVisible = true
            this.subscriptionForm.model = {
              monthlySubscriptionDate: '',
              delivery: [],
              slackChannel: ''
            }
          } else {
            this.currentAction = 'update'
            this.checkForDeleteMonthly = true

            // Prefilling latest value 
            this.subscriptionForm.model.monthlySubscriptionDate = this.userReportPreferences.data.date_selection
            this.subscriptionForm.model.slackChannel = this.userReportPreferences.data.slack_channel
            if (this.userReportPreferences.data.email_preference === "True") {
              this.subscriptionForm.model.delivery.push('email')
            }
            if (this.userReportPreferences.data.slack_preference === "True") {
              this.subscriptionForm.model.delivery.push('slack')
            }
            this.openSubscribeUnsubscribeDialogVisible = true
          }
        })
      } else if ( action === 'subscribe' && title === 'CxDR Threat Weekly Report') {
        this.openSubscribeUnsubscribeDialogVisibleWeekly = true
        this.$store.dispatch(SENDGRID_REPORT_PREFERENCES_FETCH, {
          userEmail: this.userProfile.email,
          dateSelection: "monday"
        }).then(() => {
          if (this.userReportPreferences.data === "none") {
            this.checkForDelete = false
          } else {
            if (this.userReportPreferences.data.date_selection === 'monday') {
              this.checkForDelete = true
            } else {
              this.checkForDelete = false
            }
          }
        })

      } else {
        // DO nothing
      }
    },
    openUnsubscribeDialog () {
      this.openSubscribeUnsubscribeDialogVisible = false
      this.openUnsubscribeDialogVisible = true
      this.openSubscribeUnsubscribeDialogVisibleWeekly = false
    },
    openSubscribeSuccessDialog () {
      // console.log(this.subscriptionForm);
      let entries = {
        "useremail": this.userProfile.email,
        "emailPreference": true,
        "slackPreference": this.subscriptionForm.model.delivery.includes('slack'),
        "dateTime": this.subscriptionForm.model.monthlySubscriptionDate ? this.subscriptionForm.model.monthlySubscriptionDate : "1",
        "slackChannel": this.subscriptionForm.model.slackChannel ? this.subscriptionForm.model.slackChannel : "N/A"
      }
      this.$store.dispatch(SENDGRID_REPORT_ENTRIES_CREATE, entries).then(data => {
        this.openSubscribeSuccessDialogVisible = true
        this.savedPreference = true
      })
      this.openSubscribeUnsubscribeDialogVisible = false
      this.openSubscribeSuccessDialogVisible = true
    },
    openUpdateSuccessDialog() {
      let entries = {
        "useremail": this.userProfile.email,
        "emailPreference": this.subscriptionForm.model.delivery.includes('email'),
        "slackPreference": this.subscriptionForm.model.delivery.includes('slack'),
        "dateTime": this.subscriptionForm.model.monthlySubscriptionDate ? this.subscriptionForm.model.monthlySubscriptionDate : "1",
        "slackChannel": this.subscriptionForm.model.slackChannel
      }
      this.$store.dispatch(SENDGRID_REPORT_UPDATE_REQUEST, entries).then(data => {
        this.$message({
          type: 'success',
          message: 'Preferences have been updated successfully.'
        })
        this.openSubscribeUnsubscribeDialogVisible = false
      }).catch(() => {
        this.$message({
          type: 'error',
          message: 'Something went wrong.'
        })
      })
    },
    unsubscribe() {
      this.$store.dispatch(SENDGRID_REPORT_DELETE_REQUEST, {
        userEmail: this.userProfile.email,
        dateSelection: this.userReportPreferences.data.date_selection
      }).then(() => {
        this.openUnsubscribeDialogVisible = false
        if (this.userReportPreferences.data.date_selection === "monday") {
          this.savedPreferenceWeekly = false
        } else {
          this.savedPreference = false
        }
        // this.subscriptionForm = {}
      }).catch(() => {
        this.openSubscribeUnsubscribeDialogVisible = false
        this.openSubscribeUnsubscribeDialogVisibleWeekly = false
        console.log(this.userReportPreferences.date_selection)
        this.$message({
          type: 'error',
          message: 'Something went wrong.'
        })
      })
    },
    openSubscribeSuccessDialogWeekly() {
      let entries = {
        "useremail": this.userProfile.email,
        "emailPreference": true,
        "slackPreference": false,
        "dateTime": "monday",
        "slackChannel": this.subscriptionForm.model.slackChannel ? this.subscriptionForm.model.slackChannel : "N/A"
      }
      this.$store.dispatch(SENDGRID_REPORT_ENTRIES_CREATE, entries).then(data => {
        this.openSubscribeSuccessDialogVisible = true
        this.savedPreferenceWeekly = true
      })
      this.openSubscribeUnsubscribeDialogVisibleWeekly = false
      this.openSubscribeSuccessDialogVisible = true
    },
    openAddonChannelDialog() {
      this.openSubscribeUnsubscribeDialogVisible = false
      this.openAddChannelDialogVisible = true
    },
    redirectTo(routePath) {
      this.$router.push(routePath)
    },
    runnowEntryRequest() {
      if (this.reportSubscriptionType === 'Monthly') {
        let entries = {
          "useremail": this.userProfile.email,
          "emailPreference": "runnow-monthly"
        }
        this.$store.dispatch(SENDGRID_REPORT_RUNNOW_CREATE, entries).then(date => {
          this.openRunNowDialogVisible = false
          this.openSubscribeDialogForRunnow = true
        })
      } else {
        let entries = {
          "useremail": this.userProfile.email,
          "emailPreference": "runnow-weekly"
        }
        this.$store.dispatch(SENDGRID_REPORT_RUNNOW_CREATE, entries).then(date => {
          this.openRunNowDialogVisible = false
          this.openSubscribeDialogForRunnow = true
        })
      }
    }
  },
  components: {
    PageHeaders
  },
  computed: {
    ...mapGetters(['userProfile', 'userReportPreferences'])
  },
  created () {
    this.$store.dispatch(SENDGRID_REPORT_PREFERENCES_FETCH, {
      userEmail: this.userProfile.email,
      dateSelection: "user_preferences_all"
    }).then(() => {
      console.log(this.userReportPreferences)
      if (this.userReportPreferences.data.includes("1") || this.userReportPreferences.data.includes("15")) {
        this.savedPreference = true
      }

      if (this.userReportPreferences.data.includes("monday")) {
        this.savedPreferenceWeekly = true
      }
    })
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.report-graph-logo {
    height: 172px;
    width: 172px;
    border-radius: 0;
}

.set-up-confluera {
    padding: 3rem 0;
}

.container {
  margin-top: 14px;
  margin-bottom: 14px;
}

.text-format {
  height: 22px;
  width: 104px;
  color: #292c32;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 22px;
}

.el-form-item {
  margin-bottom: 0px !important;
}

.el-radio-group {
  padding: 30px;
}

.subscription-dialog .el-dialog {
  width: 75%;
}

.success-logo, .slack-logo, .cancel-logo {
  display: flex;
  justify-content: center;
  margin: 30px 0px;
}

.run-now {
  color:#3FA2F7;
}
</style>


// WEBPACK FOOTER //
// src/views/reports/ReportsTemplate.vue